// Algorithm for calculating reference number
export default function resolveOrderNumberRs(orderNumber, cart, referenceModel) {
    const rsPrefix = {
        'Beograd': 'BG',
        'Novi Sad': 'NS',
        'Beograd, Karaburma': 'BG2',
        'Niš': 'NI',
        'Čačak': 'CA'
    };
    let shippingAddressSet = cart && cart.shipping_addresses && cart.shipping_addresses.length > 0;

    if (!shippingAddressSet) {
        return referenceModel + '-' + orderNumber
    }

    let firstName = shippingAddressSet && cart.shipping_addresses[0].firstname;
    let lastName = shippingAddressSet && cart.shipping_addresses[0].lastname;

    if (firstName != 'Emmezeta') {
        return referenceModel + '-' + orderNumber
    }

    if (rsPrefix[lastName]) {
        return rsPrefix[lastName] + '-' + orderNumber
    } else {
        return referenceModel + '-' + orderNumber
    }
}
